import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import AuthProtected from "./AuthProtected";
import { getAuthToken, getUserData } from "../../Actions/common";
import RouteGuardComponent from "./RouteGuard";
import NotFoundPage from "../../Sections/NotFoundPage";
import UnauthorizedIPPage from "../../utils/UnauthorizedIPPage";
import RouteManager from "./AllRoutes";
import useIpRestrictionCheck from "../../hooks/useIpRestrictionCheck";
import { FullPageLoader } from "../Common/FullPageLoader";
import { ForbiddenPage } from "../Common/ForbiddenPage";
import IpBlockedPage from "../Common/IpBlocked";
import CustomSnackbar from "../../Sections/Common/snackBar";

const Index = () => {
    const { privateRoutes, publicRoutes } = RouteManager();
    const [ok, setOk] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    //   const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token") ? getAuthToken() : null;
    const userData = localStorage.getItem("userData") ? getUserData() : null;
    const navigate = useNavigate();

    const { ipRestrictionData, isCheckingIp, isIpBlocked, blockMessage } = useIpRestrictionCheck();
    // const { addNotifications } = useNotification();
    // socket.emit("join", userId);

    // useEffect(() => {
    //     if (userId) {
    //         socket.on(
    //             "newNotification",
    //             (notificationArray, pushNotification) => {
    //                 addNotifications(notificationArray, userId);

    //                 if (pushNotification) {
    //                     if ("Notification" in window) {
    //                         if (Notification.permission === "granted") {
    //                             const notification = new Notification(
    //                                 `New Message From Sanction Screening`,
    //                                 {
    //                                     body: `${notificationArray[0]?.message}`,
    //                                     // icon: logo,
    //                                 }
    //                             );
    //                         }
    //                     } else {
    //                         console.warn(
    //                             "This browser does not support notifications."
    //                         );
    //                     }
    //                 }
    //             }
    //         );
    //         socket.on("allNotifications", (notificationArray) => {
    //             addNotifications(notificationArray, userId);
    //         });
    //         return () => {
    //             socket.off("newNotification");
    //             socket.off("allNotifications");
    //         };
    //     }
    // }, []);
    // const getIpAddress = async () => {
    //     try {
    //         const response = await axios.get(
    //             "https://api.ipify.org?format=json"
    //         );
    //         const result = response?.data || "103.254.35.218";
    //         await checkWhitelistRestrictionAction(result?.ip)
    //             .then((res) => {
    //                 if (res?.data?.status == 200) {
    //                     setIsValidIp(true);
    //                 } else {
    //                     setIsValidIp(false);
    //                 }
    //             })
    //             .catch((error) => {
    //                 setIsValidIp(false);
    //                 setSnackbar({
    //                     open: true,
    //                     message: "UnAuthorize IP",
    //                     severity: "error",
    //                 });
    //             })
    //             .finally(() => {
    //                 setLoading(false);
    //             });
    //     } catch (error) {
    //         console.error("Error fetching IP information:", error.message);
    //     }
    // };

    //   useEffect(() => {
    //     // getIpAddress();

    //     const interval = setInterval(() => {
    //       // getIpAddress();
    //     }, 400000);

    //     return () => clearInterval(interval);
    //   }, []);

    // useEffect(() => {
    //   if (token && userData) {
    //     setOk(true);
    //   } else {
    //     setOk(false);
    //     if (window.location.pathname === "/") {
    //       navigate("/login");
    //     } else {
    //       setTimeout(() => {
    //         navigate("/login");
    //       }, 2500);
    //     }
    //   }
    // }, [token, userData, navigate]);

    const isPublicRoute = (currentPath, publicRoutes) => {
        return publicRoutes.some((route) => {
            // Exact match
            if (route.path === currentPath) {
                return true;
            }

            // Dynamic route match (e.g., /checkout-payment/:slug)
            if (route.path.includes(":")) {
                const routeParts = route.path.split("/");
                const pathParts = currentPath.split("/");

                if (routeParts.length !== pathParts.length) {
                    return false;
                }

                return routeParts.every((part, index) => {
                    return part.startsWith(":") || part === pathParts[index];
                });
            }

            return false;
        });
    };

    useEffect(() => {
        if (token && userData) {
            setOk(true);
        } else {
            setOk(false);
            const currentPath = window.location.pathname;

            // Exclude IP restriction pages from login redirect
            const ipRestrictionRoutes = [
                "/ip-blocked",
                "/unauthorized-ippage",
            ];

            if (ipRestrictionRoutes.includes(currentPath)) {
                return;
            }

            // Special case: checkout-payment route should always be accessible
            if (currentPath.startsWith("/plan-payment")) {
                return; // Don't redirect to login for checkout-payment routes
            }

            if (!isPublicRoute(currentPath, publicRoutes)) {
                navigate("/login");
                setSnackbar({
                    open: true,
                    message: "Session expired please login again",
                    severity: "info",
                });
            }
        }
    }, [token, userData, navigate, isIpBlocked, publicRoutes]);

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    if (isCheckingIp) {
        return <FullPageLoader isLoading={isCheckingIp} />;
    }

    if (isIpBlocked) {
        return <IpBlockedPage message={blockMessage} loading={isCheckingIp} />;
    }

    if (ipRestrictionData && ipRestrictionData?.hasError) {
        return <ForbiddenPage />;
    }

    if (ipRestrictionData && !ipRestrictionData?.accessGranted) {
        return <UnauthorizedIPPage loading={isCheckingIp} />;
    }

    return (
        <>
            <Routes>
                {/* Redirect authenticated users */}
                {token && (
                    <Route
                        path="/"
                        element={<Navigate to="/dashboard" replace />}
                    />
                )}

                {/* Protected Routes */}
                <Route path="/" element={<AuthProtected ok={ok} />}>
                    {privateRoutes.map((route, idx) => (
                        <Route
                            key={idx}
                            path={route.path}
                            element={
                                <RouteGuardComponent
                                    checkAccess={route.checkAccess}
                                    slug={route.slug}
                                >
                                    {route.component}
                                </RouteGuardComponent>
                            }
                        />
                    ))}
                </Route>

                {/* Public Routes */}
                {publicRoutes.map((route, idx) => (
                    <Route
                        key={idx}
                        path={route.path}
                        element={route.component}
                    />
                ))}

                {/* 404 */}
                <Route path="*" element={<NotFoundPage />} />
            </Routes>

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </>
    );
};

export default Index;
